import { Injectable, Pipe } from '@angular/core';

/*
  class  KeyValueFilterPipe pipe.

  Ex of use:  <li *ngFor="#u of myObject | keyValueFilter">First Name: {{u.key}} <br> Last Name: {{u.value}}</li>

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on  Angular 2 Pipes.
*/
@Pipe({
  name: 'keyValueFilter'
})
@Injectable()
export class KeyValueFilterPipe {


  //
  transform(value: any, args: any[] = null): any {

    if (value==null) return null;
    
    return Object.keys(value).map(function(key) {
      let pair = {};
      let k = 'key';
      let v = 'value'

      pair[k] = key;
      pair[v] = value[key];

      return pair;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/key-value-filter-pipe.ts